import validate from "/builds/nht4944308/brands/umarketpro/webapp/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/builds/nht4944308/brands/umarketpro/webapp/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}